import React from 'react';

import { FactionInfo } from '../../../constants/EntertainmentGames/gameFaction';
import { getChessItemByJoyachessItemNo } from '../../../constants/EntertainmentGames/joyachessPiece';
import { PieceDesigns } from '../../../models/SpaceStore/MultiplayerGame';
import { useFileStore } from '../../../stores/FileStore';

import './ChessPieceLayoutGroup.css';

interface ChessPieceLayoutGroupProps {
  size: number; // Number of rows/columns for the ChessPieceLayoutGroup
  pieces: { x: number; y: number }[]; // Array of pieces with their positions
  pieceDesigns: PieceDesigns; // Object of piece designs
  iconImageSource?: string | undefined;
  //
  faction: FactionInfo | undefined;
}

export const ChessPieceLayoutGroup: React.FC<ChessPieceLayoutGroupProps> = ({
  size,
  pieces,
  pieceDesigns,
  iconImageSource,
  faction,
}) => {
  const renderPiece = (piece: { x: number; y: number }, pieceKey: string) => {
    const pieceDesign = pieceDesigns[pieceKey];
    if (!pieceDesign) return null;

    const item = getChessItemByJoyachessItemNo(pieceDesign.itemId);
    const fileName = faction?.side
      ? item?.visual?.faction?.[faction.side] ?? item?.visual?.filePrefix
      : item?.visual?.filePrefix;

    const pieceImage =
      pieceDesign.image?.fileId &&
      useFileStore.getState().getFileUrl(pieceDesign.image?.fileId);

    return (
      <div
        style={{
          aspectRatio: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <img
          src={fileName}
          alt="Chess Piece"
          style={{
            width: '100%',
            height: '100%',
          }}
        />
        {pieceDesign.icon ? (
          <div
            style={{
              position: 'absolute',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={iconImageSource}
              alt="Icon"
              style={{
                width: '72%',
                height: '72%',
                border: '1px solid #cccccc50',
                borderRadius: '50%',
                aspectRatio: 1,
              }}
            />
          </div>
        ) : pieceImage ? (
          <div
            style={{
              position: 'absolute',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={pieceImage}
              alt="Icon"
              style={{
                width: '72%',
                height: '72%',
                border: '1px solid #cccccc50',
                borderRadius: '50%',
                aspectRatio: 1,
              }}
            />
          </div>
        ) : (
          <span
            style={{
              position: 'absolute',
              display: 'flex',
              color: 'white',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '1.25rem',
            }}
          >
            {pieceDesign.text}
          </span>
        )}
      </div>
    );
  };

  const pieceKeys = Object.keys(pieceDesigns);

  return (
    <div className="chess-piece-layout-group" style={{ flexDirection: 'row' }}>
      {Array.from({ length: size * size }, (_, index) => {
        const row = Math.floor(index / size);
        const col = index % size;
        const pieceIndex = pieces.findIndex((p) => p.x === row && p.y === col);

        const piece = pieces[pieceIndex];
        const pieceKey = pieceKeys[pieceIndex];

        return (
          <div key={index}>
            {pieceIndex !== -1 &&
              piece != undefined &&
              pieceKey != undefined &&
              renderPiece(piece, pieceKey)}
          </div>
        );
      })}
    </div>
  );
};
